"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecycleBinApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var RecycleBinApi = /** @class */ (function () {
    function RecycleBinApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询回收站对象列表
     * @method GET 查询回收站对象列表
     *
     */
    RecycleBinApi.prototype.RecycleBin = function () {
        return this.http
            .url("/api/RecycleBin")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 恢复回收站对象
     * @method POST 恢复回收站对象
     *
     * @params id 无说明
     */
    RecycleBinApi.prototype.restore = function (id) {
        return this.http
            .url("/api/RecycleBin/" + id + "/restore")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 删除回收站对象
     * @method POST 删除回收站对象
     *
     * @params id 无说明
     */
    RecycleBinApi.prototype.delete = function (id) {
        return this.http
            .url("/api/RecycleBin/" + id + "/delete")
            .addSecurityHeaders()
            .support('POST');
    };
    RecycleBinApi.diOptions = di_1.default.options({
        name: "RecycleBinApi",
        scope: "Singleton"
    });
    return RecycleBinApi;
}());
exports.RecycleBinApi = RecycleBinApi;
exports.default = RecycleBinApi;
